import React from 'react';
import { css } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import { colors, fontStyles, spacing } from '../../styles';

const NotificationHeader: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div
      css={css`
        text-align: center;
        margin-bottom: ${spacing.hecto};
      `}
    >
      <p
        css={css`
          ${fontStyles.dog};
          color: var(--secondary-text);
          margin-bottom: ${spacing.regular};
          html[data-theme='dark'] & {
            color: ${colors.sugar};
            opacity: 0.8;
          }
        `}
      >
        {t('notifications.headerDescription')}
      </p>
    </div>
  );
};

export default NotificationHeader;
